/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CancellationDetails
 */
export interface CancellationDetails {
    /**
     * 
     * @type {string}
     * @memberof CancellationDetails
     */
    comment?: string;
}

/**
 * Check if a given object implements the CancellationDetails interface.
 */
export function instanceOfCancellationDetails(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CancellationDetailsFromJSON(json: any): CancellationDetails {
    return CancellationDetailsFromJSONTyped(json, false);
}

export function CancellationDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): CancellationDetails {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'comment': !exists(json, 'comment') ? undefined : json['comment'],
    };
}

export function CancellationDetailsToJSON(value?: CancellationDetails | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'comment': value.comment,
    };
}

